import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { StoreType } from "../../../../core/store/reducers";
import { resetOrderIdices } from "../ordersReportUXSlice";
import { PageIndex } from "../../../models";
import { setOrdersIndexThunk } from "../thunks/loadOrdersReport";

export const useOrdersReportIndex = () => {
	const pageIndex = useSelector<StoreType, PageIndex>(s => s.ux.reports.ordersReport.index);

	const dispatch = useDispatch();
	const dispatchSetIndex = React.useCallback((index: PageIndex) => dispatch(setOrdersIndexThunk(index)), [
		dispatch,
	]);
	const dispatchResetIndex = React.useCallback(() => dispatch(resetOrderIdices()), [dispatch]);

	return [pageIndex, dispatchSetIndex, dispatchResetIndex] as [
		typeof pageIndex,
		typeof dispatchSetIndex,
		typeof dispatchResetIndex
	];
};
